var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 26.6667L20.0002 20L13.3335 26.6667",
    stroke: "#FF0990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20V35",
    stroke: "#FF0990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.983 30.6499C35.6086 29.7637 36.8927 28.3614 37.6328 26.6643C38.3729 24.9672 38.5267 23.072 38.07 21.2778C37.6134 19.4835 36.5722 17.8925 35.1108 16.7557C33.6494 15.6189 31.8511 15.0012 29.9997 14.9999H27.8997C27.3952 13.0487 26.455 11.2372 25.1496 9.70159C23.8442 8.16602 22.2078 6.94635 20.3632 6.13428C18.5186 5.32221 16.5139 4.93886 14.4999 5.01307C12.4858 5.08728 10.5148 5.6171 8.73499 6.56271C6.95517 7.50832 5.41288 8.8451 4.22406 10.4726C3.03524 12.1 2.23084 13.9758 1.87132 15.9589C1.51181 17.942 1.60653 19.9808 2.14838 21.922C2.69023 23.8633 3.66509 25.6564 4.99969 27.1666",
    stroke: "#FF0990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6668 26.6667L20.0002 20L13.3335 26.6667",
    stroke: "#FF0990",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.95df8f2cba52f25f37834fcca22737e7.svg";
export { ForwardRef as ReactComponent };